import { buildChatAssetUrl, buildChatAssetUrlWithVariant } from '../composer/chatAssetUtils';

export const createEventAssetHelpers = ({
  apiUrl,
  flyerImagePath,
  messageImagePath,
}) => {
  const buildAssetUrl = (root, file) => buildChatAssetUrl({ apiUrl, root, file });
  const buildFlyerUrl = (file, variant = 'card') =>
    buildChatAssetUrlWithVariant({ apiUrl, root: flyerImagePath, file, variant });
  const buildMessageImageUrl = (file, variant = 'proxy') =>
    buildChatAssetUrlWithVariant({ apiUrl, root: messageImagePath, file, variant });
  const applyLandscapeContain = (target) => {
    if (!target) return;
    const { naturalWidth, naturalHeight } = target;
    if (!naturalWidth || !naturalHeight) return;
    if (naturalWidth > naturalHeight) {
      target.style.objectFit = 'contain';
      target.style.objectPosition = 'center';
      return;
    }
    target.style.objectFit = '';
    target.style.objectPosition = '';
  };

  return {
    buildAssetUrl,
    buildFlyerUrl,
    buildMessageImageUrl,
    applyLandscapeContain,
  };
};
